import React, { Fragment, useState, useEffect } from "react";

import { func, bool, object, string, any, array } from "prop-types";

import { connect } from "react-redux";
import * as style from "./styles.module.scss";
import history from "../../history";
import {
  clearErrors,
  holidayRequestData,
  postHolidayRequestForm,
} from "../../redux/actions";
import { HolidayStatus } from "../../helpers/holiday";
import { PulseLoader } from "../../common";
import HolidayTryAgain from "../../components/HolidayTryAgain";

const HolidayContainer = ({
  children = () => {},
  isLoading,
  firstName,
  lastName,
  holidayData = undefined,
  holidayHistoryData,
  errors,
  clearErrorsWithSource,
  requestHoliday,
  candidateRef,
  postHolidayRequestFormFunc,
  holidayRequestFormLoading,
  holidayRequestFormSubmitted,
  permissions,
  responsibleTeam,
}) => {
  const handleTryAgain = () => {
    clearErrorsWithSource("holiday");
    requestHoliday();
  };
  const holidayErrors =
    errors && errors.filter((error) => error.source === "holiday");

  const [holidayStatus, setHolidayStatus] = useState(HolidayStatus.Loading);

  useEffect(() => {
    if (holidayData.isLoading) {
      return setHolidayStatus(HolidayStatus.Loading);
    }
    if (holidayErrors && holidayErrors.length > 0) {
      return setHolidayStatus(HolidayStatus.Failed);
    }
    if (!holidayData || holidayData.holidayData) {
      return setHolidayStatus(HolidayStatus.NoData);
    }
    return setHolidayStatus(HolidayStatus.Success);
  }, [holidayData, errors, isLoading]);

  switch (holidayStatus) {
    case HolidayStatus.Loading:
      return (
        <div
          className={`w-100 ${style.holiday__loader} d-flex flex-column justify-content-center align-items-center`}
        >
          <PulseLoader />
          <h2 className="mt-2 text-center">
            Collecting your holiday information
          </h2>
        </div>
      );
    case HolidayStatus.NoData:
      return (
        <Fragment style={{ maxWidth: "700px" }}>
          <div
            style={{
              padding: "200px 40px",
              display: "flex",
              textAlign: "center",
              flexDirection: "column",
            }}
            className="container"
          >
            <h2 className="tw-text-center tw-font-bold tw-text-xl">
              There is no holiday data to display.
            </h2>
            <h6>
              For more information about holiday, please contact our Customer
              Success team,
              <br /> Monday - Friday between 9am - 5.30pm on 01233 515169 or via
              email at{" "}
              <a href="mailto:customer.success@hrgo.co.uk">
                customer.success@hrgo.co.uk
              </a>
            </h6>
            <div
              style={{
                display: "flex",
                padding: "30px 0",
                justifyContent: "flex-end",
              }}
            >
              <button
                onClick={() => history.push("/profile")}
                style={{ backgroundColor: "lightgray" }}
                className="btn"
              >
                Back to My Account
              </button>
            </div>
          </div>
        </Fragment>
      );
    case HolidayStatus.Success:
      return (
        <Fragment>
          {children({
            isLoading,
            holidayData,
            holidayHistoryData,
            requestHoliday,
            errors,
            clearErrorsWithSource,
            handleTryAgain,
            firstName,
            lastName,
            candidateRef,
            postHolidayRequestFormFunc,
            holidayRequestFormLoading,
            holidayRequestFormSubmitted,
            permissions,
            responsibleTeam,
          })}
        </Fragment>
      );

    case HolidayStatus.Failed:
      return <HolidayTryAgain handleTryAgain={handleTryAgain} />;

    default:
      return <Fragment>def</Fragment>;
  }
};

HolidayContainer.propTypes = {
  children: func,
  isLoading: bool.isRequired,
  firstName: string,
  lastName: string,
  holidayData: object,
  holidayHistoryData: array,
  errors: any,
  clearErrorsWithSource: func,
  requestHoliday: func,
  postHolidayRequestFormFunc: func,
  candidateRef: string,
  holidayRequestFormLoading: bool,
  holidayRequestFormSubmitted: any,
  permissions: object,
};

const mapStateToProps = ({
  core: {
    app: { firstName, lastName, candidateRef, permissions, responsibleTeam },
    holidayData: { ...holidayData },
    holidayHistoryData: [...holidayHistoryData],
    errors,
    holidayRequest: { holidayRequestFormLoading, holidayRequestFormSubmitted },
  },
}) => ({
  firstName,
  lastName,
  holidayData,
  holidayHistoryData,
  candidateRef,
  errors,
  holidayRequestFormLoading,
  holidayRequestFormSubmitted,
  permissions,
  responsibleTeam,
});

const mapDispatchToProps = {
  clearErrorsWithSource: clearErrors,
  requestHoliday: holidayRequestData,
  postHolidayRequestFormFunc: postHolidayRequestForm,
};

const withRedux = connect(mapStateToProps, mapDispatchToProps);

export default withRedux(HolidayContainer);
